export default __webpack_public_path__ + "static/doodle-footer-558ba591c242c69480f7a147b6db914e.svg";